<template>
	<div>
		<section class="bg-gray-100 pb-8 pt-36">
			<div class="container mx-auto px-8" style="max-width: 1500px">
				<!-- widget cards -->
				<div class="grid gap-3 grid-cols-1 lg:grid-cols-5">
					<div class="shadow-xl bg-white p-4 rounded-lg flex-col items-center justify-center">
						<p class="text-xs md:text-sm uppercase text-purple-600 px-2 py-1 bg-white -mx-4 rounded-t">Metaverse Punk</p>
						<div class="flex items-center text-purple-600 mt-2">
							<p class="text-xl md:text-3xl lg:text-5xl font-semibold">
								{{ mvpCount }}
							</p>
							<span class="text-xl md:text-3xl lg:text-5xl mx-2">|</span>
							<p class="text-base font-semibold">{{ mvpCount * 300 }} $PZA/DAY</p>
						</div>
					</div>
					<div class="shadow-xl bg-white p-4 rounded-lg flex-col items-center justify-center">
						<p class="text-xs md:text-sm uppercase text-purple-600 px-2 py-1 bg-white -mx-4 rounded-t">Average Punk</p>
						<div class="flex items-center text-purple-600 mt-2">
							<p class="text-xl md:text-3xl lg:text-5xl font-semibold">
								{{ avpCount }}
							</p>
							<span class="text-xl md:text-3xl lg:text-5xl mx-2">|</span>
							<p class="text-base font-semibold">{{ avpCount * 50 }} $PZA/DAY</p>
						</div>
					</div>
					<div class="shadow-xl bg-white p-4 rounded-lg flex-col items-center justify-center">
						<p class="text-xs md:text-sm uppercase text-purple-600 px-2 py-1 bg-white -mx-4 rounded-t">My $PZA balance</p>
						<div class="flex items-center justify-between mt-2">
							<p class="text-xl md:text-3xl lg:text-5xl font-semibold text-purple-600">
								{{ balance }}
							</p>
						</div>
					</div>
					<div class="shadow-xl bg-white p-4 rounded-lg flex-col items-center justify-center">
						<p class="text-xs md:text-sm uppercase text-purple-600 px-2 py-1 bg-white -mx-4 rounded-t">OFFCHAIN</p>
						<div class="flex justify-between mt-3 w-full">
							<button
								:disabled="!metamaskAddress || (metamaskAddress && pizzaBalance == 0)"
								@click="transferModal"
								:class="
									metamaskAddress && pizzaBalance > 0
										? 'hover:bg-purple-600 hover:text-white cursor-pointer'
										: 'cursor-default'
								"
								class="border border-purple-300 bg-white px-4 py-2 text-purple-600 uppercase font-semibold rounded mr-2"
							>
								Transfer
							</button>
						</div>
					</div>
					<div class="shadow-xl bg-white p-4 rounded-lg flex-col items-center justify-center">
						<div class="flex justify-between items-center">
							<p class="text-xs md:text-sm uppercase text-purple-600 px-2 py-1 bg-white -mx-4 rounded-t">ONCHAIN</p>
							<button class="text-xs text-purple-600 underline uppercase" v-if="metamaskAddress" @click="addTokenToWallet">
								Add $PZA to metamask
							</button>
						</div>

						<div class="flex justify-between mt-3 w-full">
							<button
								:disabled="!metamaskAddress"
								@click="openWithdrawModal('deposit')"
								:class="
									metamaskAddress && pizzaBalance > 0
										? 'hover:bg-purple-600 hover:text-white cursor-pointer'
										: 'cursor-default'
								"
								class="border border-purple-300 bg-white px-4 py-2 text-purple-600 uppercase font-semibold rounded"
							>
								Deposit
							</button>
							<button
								:disabled="!metamaskAddress"
								@click="openWithdrawModal('withdraw')"
								:class="
									metamaskAddress && pizzaBalance > 0
										? 'hover:bg-purple-600 hover:text-white cursor-pointer'
										: 'cursor-default'
								"
								class="border border-purple-300 bg-white px-4 py-2 text-purple-600 uppercase font-semibold rounded"
							>
								Withdraw
							</button>
						</div>
					</div>
				</div>
				<!-- secondary nav -->
				<div class="flex items-center justify-between h-16 w-full rounded mt-12">
					<div class="flex items-center justify-center">
						<button
							:disabled="!metamaskAddress"
							@click="
								!myItems ? getProductsBought() : '';
								myItems = !myItems;
								showCart = false;
							"
							:class="metamaskAddress ? 'hover:bg-purple-600 hover:text-white cursor-pointer' : 'cursor-default'"
							class="text-xs md:text-base border bg-white border-purple-300 px-4 py-2 text-purple-600 uppercase font-semibold rounded mr-2"
						>
							{{ !myItems ? 'My items' : 'Back to shop' }}
						</button>
						<button
							v-if="!showCart"
							:disabled="!metamaskAddress"
							:class="metamaskAddress ? 'hover:bg-purple-600 hover:text-white cursor-pointer' : 'cursor-default'"
							@click="toggleCart"
							class="text-xs md:text-base border bg-white px-4 border-purple-300 py-2 text-purple-600 uppercase font-semibold rounded"
						>
							Checkout {{ cart.length > 0 ? cart.length : '' }}
						</button>
						<!-- <p v-if="cartTotal && !showCart" class="text-purple-600 mx-4 font-semibold">
              {{cartTotal}} $PZA TOTAL
            </p> -->
					</div>
					<div v-show="!showCart && !myItems" class="relative inline-block text-left">
						<button-with-dropdown :sort="priceOrder" @sortPrice="sortPrice" @include-past="includePast" />
					</div>
				</div>
				<!-- /*------------- MY ITEMS SECTION -----------*/ -->
				<div
					v-if="myItems"
					:class="
						productsBought && productsBought.length
							? 'mt-12 grid gap-3 grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4'
							: 'min-h-screen'
					"
				>
					<p v-if="!productsBought || productsBought.length === 0" class="mt-8 text-xl text-purple-600 font-semibold">
						You didn't purchase anything yet.
					</p>
					<product
						v-for="product in productsBought"
						:key="product.id"
						:product="product"
						:can-rate="canRate"
						:canBuy="false"
						:hideButton="true"
					/>
				</div>
				<Cart
					@toggle="toggleCart"
					@removeItem="removeItemFromCart"
					@finalizeOrder="finalizeOrder"
					@emptyCart="emptyCart"
					:wallet="metamaskAddress"
					:cart="cart"
					v-else-if="showCart"
				/>
				<div v-else class="mt-12 grid gap-3 grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
					<product
						v-for="product in displayProducts"
						:key="product.id"
						:product="product"
						:canRate="canRate"
						:canBuy="canBuy(product.price)"
						@buy="addToCart"
					/>
				</div>
			</div>
		</section>
		<transfer-modal
			@gift="
				getPizzaBalance();
				openTranferModal = false;
			"
			:open="openTranferModal"
			@close="openTranferModal = false"
		/>
		<on-chain-modal
			@fetch="setFetching"
			:fetching="fetching"
			@deposit="addToTmpBalance"
			@withdraw="removeFromTmpBalance"
			:wallet="metamaskAddress"
			:open="openOnChainModal"
			:balance="Number(pizzaBalance)"
			@close="
				openOnChainModal = { open: false, type: 'deposit' };
				fetching = false;
			"
		/>
	</div>
</template>

<script>
import TransferModal from '../../components/TransferModal.vue';
import OnChainModal from '../../components/OnChainModal.vue';
import { ADDRESS } from '@/util/constants/pizza/contract.js';
import Product from '../../components/Product.vue';
import Cart from './Cart.vue';
import ButtonWithDropdown from '@/components/ButtonWithDropdown';
import axios from 'axios';
import { mapGetters, mapActions } from 'vuex';
import Web3 from 'web3';

// const SHOP_URL = "https://averagepunks.app";
const SHOP_URL = 'https://averagepunks.app';

export default {
	name: 'Shop',
	components: {
		TransferModal,
		Cart,
		OnChainModal,
		Product,
		ButtonWithDropdown,
	},
	mounted() {
		this.getProducts();
	},
	data: () => {
		return {
			wallet: '',
			discord: '',
			tmpBalance: 0,
			web3Shop: null,
			myItems: false,
			openTranferModal: false,
			openOnChainModal: { open: false, type: 'deposit' },
			include_past: true,
			priceOrder: 'none',
			pizzaBalance: 0,
			toggleBuy: true,
			mvpCount: 0,
			pzaPerMVP: 10,
			avpCount: 0,
			pzaPerAVP: 5,
			products: [],
			sig: '',
			msg: '',
			productsBought: null,
			open: false,
			giveTo: '',
			ammountToGive: 1,
			cart: [],
			showCart: false,
			fetching: false,
			withdrawAllowed: false,
			blockHeight: 0,
		};
	},

	computed: {
		...mapGetters({
			metamaskAddress: 'connection/metamaskAddress',
			balance: 'balance/amount',
		}),

		displayProducts() {
			let products = this.include_past ? this.products : this.availableProducts;
			if (this.priceOrder == 'low') products.sort((a, b) => a.price - b.price);
			else if (this.priceOrder == 'high') products.sort((a, b) => b.price - a.price);
			else {
				products.sort((a, b) => b.id - a.id);
				products.sort((a, b) => Number(a.sold) - Number(b.sold));
			}
			return products;
		},
		availableProducts() {
			return this.products.filter((p) => !p.sold);
		},
		canRate() {
			if (this.metamaskAddress && this.pizzaBalance) {
				return true;
			}
			return false;
		},
	},
	watch: {
		metamaskAddress: {
			immediate: true,
			handler: async function (val) {
				if (val) {
					try {
						if (window.ethereum) {
							this.web3Shop = this.web3Shop ? this.web3Shop : new Web3(window.ethereum);
						}
						window.web3Shop = this.web3Shop;
						this.getPunksCount();
						this.getPizzaBalance();
						this.claimTokens();
						// this.getProductsBought();
						this.canWithdraw();
					} catch (error) {
						this.showErrorMessage(error.message);
					}
				} else {
					this.pizzaBalance = 0;
					this.avpCount = 0;
					this.mvpCount = 0;
					this.myItems = false;
					this.clearAmount();
				}
			},
		},
	},

	methods: {
		...mapActions({
			setAmount: 'balance/setAmount',
			clearAmount: 'balance/clearAmount',
		}),

		async addTokenToWallet() {
			const tokenAddress = ADDRESS;
			const tokenSymbol = 'PZA';
			const tokenDecimals = 0;
			const tokenImage =
				'data:image/png;base64,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';

			try {
				// wasAdded is a boolean. Like any RPC method, an error may be thrown.
				const wasAdded = await window.ethereum.request({
					method: 'wallet_watchAsset',
					params: {
						type: 'ERC20', // Initially only supports ERC20, but eventually more!
						options: {
							address: tokenAddress, // The address that the token is at.
							symbol: tokenSymbol, // A ticker symbol or shorthand, up to 5 chars.
							decimals: tokenDecimals, // The number of decimals in the token
							image: tokenImage, // A string url of the token logo
						},
					},
				});

				if (wasAdded) {
					console.log('Thanks for your interest!');
				} else {
					console.log('Your loss!');
				}
			} catch (error) {
				console.log(error);
			}
		},
		async transferModal() {
			await this.canWithdraw();
			if (this.withdrawAllowed) return (this.openTranferModal = true);
			else {
				const currentBlock = await this.web3Shop.eth.getBlockNumber();
				return this.showErrorMessage(`The marketplace is frozen for ${20 - Math.abs(this.blockHeight - currentBlock)} blocks`);
			}
		},

		async openWithdrawModal(type) {
			await this.canWithdraw();
			if (this.withdrawAllowed) return (this.openOnChainModal = { open: true, type });
			else {
				const currentBlock = await this.web3Shop.eth.getBlockNumber();
				return this.showErrorMessage(`The marketplace is frozen for ${20 - Math.abs(this.blockHeight - currentBlock)} blocks`);
			}
		},

		setFetching(val) {
			this.fetching = val;
		},

		async addToTmpBalance(amount) {
			await this.canWithdraw();
			this.tmpBalance = +this.tmpBalance + +amount;
			this.fetching = false;
			this.openOnChainModal = { open: false, type: 'deposit' };
		},

		async removeFromTmpBalance(amount, blockHeight) {
			await this.canWithdraw();
			this.withdrawAllowed = false;
			this.blockHeight = blockHeight;
			this.tmpBalance = +this.tmpBalance - +amount;
			this.fetching = false;
			this.openOnChainModal = { open: false, type: 'deposit' };
		},

		emptyCart() {
			const cartTotal = this.cart.map((p) => p.price).reduce((previousValue, currentValue) => previousValue + currentValue, 0);
			this.cart = [];
			this.tmpBalance = +this.tmpBalance + +cartTotal;
		},

		finalizeOrder() {
			this.toggleCart();
			this.cart = [];
			this.tmpBalance = 0;
			this.getPizzaBalance();
			this.getProducts();
			this.showSuccess('You bought an item');
		},
		toggleCart() {
			this.myItems = false;
			this.showCart = !this.showCart;
		},

		removeItemFromCart({ index, price }) {
			this.cart.splice(index, 1);
			this.tmpBalance += price;
			if (!this.cart.length) this.toggleCart();
		},
		addToCart(product) {
			if (product.unique_buy) {
				const found = this.cart.find((p) => p.id === product.id);
				if (found !== undefined) return this.showErrorMessage('This item is already in your cart');
			}
			if (product.quantity < 1) {
				return this.showErrorMessage('Not available');
			}
			if (this.tmpBalance < product.price) return this.showErrorMessage('You need more $PZA');

			this.tmpBalance = this.tmpBalance - product.price;
			this.cart.push(product);
			return this.showSuccess('success');
		},
		canBuy(price) {
			if (!this.metamaskAddress) return false;
			if (this.pizzaBalance >= price) return true;
			else return false;
		},

		includePast(val) {
			this.include_past = val;
		},

		sortPrice(val) {
			this.priceOrder = val;
		},
		async getProducts() {
			try {
				const res = await axios.get(`${SHOP_URL}/products`);
				this.products = res.data.products;
			} catch (error) {
				this.showErrorMessage(error.message);
			}
		},

		async getProductsBought() {
			try {
				const res = await axios.get(`${SHOP_URL}/ownerOf`, {
					params: {
						wallet: this.metamaskAddress,
					},
				});
				this.productsBought = res.data.products;
			} catch (error) {
				this.showErrorMessage(error.message);
			}
		},

		isDisabled(product) {
			if (!this.metamaskAddress) return true;
			else if (this.metamaskAddress && this.pizzaBalance < product.price) return true;
			else if (this.metamaskAddress && product.sold) return true;
			else return false;
		},

		async buyProduct(product) {
			if (!this.withdrawAllowed) {
				const currentBlock = await this.web3Shop.eth.getBlockNumber();
				return this.showErrorMessage(`The marketplace is frozen for ${20 - Math.abs(this.blockHeight - currentBlock)} blocks`);
			}
			const web3 = this.web3Shop;
			let buyer;
			if (product.wallet.length) {
				buyer = product.wallet;
				if (!web3.utils.isAddress(product.wallet)) {
					return this.showErrorMessage('Invalid address');
				}
			} else {
				buyer = this.metamaskAddress;
			}

			this.msg =
				'Get this item for no gas, you are only exchanging it for PIZZA tokens and signing with this address ' +
				this.metamaskAddress;
			try {
				this.sig = await web3.eth.personal.sign(this.msg, this.metamaskAddress);
				// let wallet =  web3.utils.isAddress(product.wallet) ? product.wallet : this.metamaskAddress;
				await axios.post(`${SHOP_URL}/buy`, {
					productId: product.id,
					signature: this.sig,
					wallet: this.metamaskAddress,
					buyer,
					discord: product.discord,
					message: this.msg,
				});
				this.getPizzaBalance();
				this.getProducts();
				// this.getProductsBought();
				this.showSuccess('You bought an item');
			} catch (error) {
				this.showErrorMessage(error.message);
			}
		},

		async claimTokens() {
			const web3 = this.web3Shop;
			const oneDayMs = 86400000;
			let last_claim = localStorage.getItem('last_punked' + this.metamaskAddress);
			if (last_claim && last_claim > Date.now() - oneDayMs) {
				console.log('claimed less than 24h ago');
				return;
			}

			try {
				this.msg = 'Starting a session with this address ' + this.metamaskAddress;
				this.sig = await web3.eth.personal.sign(this.msg, this.metamaskAddress);

				await axios.post(`${SHOP_URL}/pizzas`, {
					signature: this.sig,
					wallet: this.metamaskAddress,
					message: this.msg,
				});
				localStorage.setItem('last_punked' + this.metamaskAddress, Date.now());
				this.getPizzaBalance();
			} catch (error) {
				this.showErrorMessage(error.message);
			}
		},

		async getPunksCount() {
			const web3 = this.web3Shop;
			let { ADDRESS: ADDRESS_MVP, ABI: ABI_MVP } = require('../../util/constants/mvp/contract.js');
			let contract = new web3.eth.Contract(ABI_MVP, ADDRESS_MVP);
			this.mvpCount = await contract.methods.balanceOf(this.metamaskAddress).call();

			let { ADDRESS, ABI } = require('../../util/constants/contract.js');
			contract = new web3.eth.Contract(ABI, ADDRESS);
			this.avpCount = await contract.methods.balanceOf(this.metamaskAddress).call();
		},

		// todo
		async getPizzaBalance() {
			const res = await axios.get(`${SHOP_URL}/pizzas`, {
				params: {
					wallet: this.metamaskAddress,
				},
			});
			this.pizzaBalance = res.data.balance;
			this.tmpBalance = this.pizzaBalance;
			this.setAmount(this.pizzaBalance);
		},

		async gift() {
			if (!this.giveTo || this.ammountToGive <= 0) return this.showErrorMessage('missing input');
			const web3 = this.web3Shop;
			this.msg = 'You are giving ' + this.ammountToGive + ' $PZA to ' + this.giveTo;
			try {
				this.sig = await web3.eth.personal.sign(this.msg, this.metamaskAddress);
				const ret = await axios.post(`${SHOP_URL}/transferPizzas`, {
					receiver: this.giveTo,
					amount: this.ammountToGive,
					wallet: this.metamaskAddress,
					message: this.msg,
					signature: this.sig,
				});
				console.log('ret ', ret);
				this.giveTo = '';
				this.ammountToGive = 1;
				this.open = false;
				this.getPizzaBalance();
				this.showSuccess(this.ammountToGive + ' $PZA sent');
			} catch (error) {
				this.showErrorMessage(error.message);
			}
		},

		async canWithdraw() {
			try {
				const res = await axios.get(`${SHOP_URL}/canWithdraw`, {
					params: { wallet: this.metamaskAddress },
				});

				console.log({ res });
				this.withdrawAllowed = res.data.allowed;
				if (!this.withdrawAllowed) {
					this.blockHeight = res.data.until;
					//this.showErrorMessage(res.data.message)
				}
			} catch (error) {
				console.log('ICI?');
				console.log(error);
				return this.showErrorMessage(error);
			}
		},

		showErrorMessage(message) {
			this.$toast.error(message, {
				position: 'bottom-right',
				timeout: 5000,
				closeOnClick: true,
				pauseOnFocusLoss: true,
				pauseOnHover: true,
				draggable: true,
				draggablePercent: 0.79,
				showCloseButtonOnHover: false,
				hideProgressBar: true,
				closeButton: 'button',
				icon: true,
				rtl: false,
			});
		},
		showSuccess() {
			this.$toast.success(`Success`, {
				position: 'bottom-right',
				timeout: 5000,
				closeOnClick: true,
				pauseOnFocusLoss: true,
				pauseOnHover: true,
				draggable: true,
				draggablePercent: 0.79,
				showCloseButtonOnHover: false,
				hideProgressBar: true,
				closeButton: 'button',
				icon: true,
				rtl: false,
			});
		},
	},
};
</script>

<style scoped>
.dropdown:hover .dropdown-menu {
	display: block;
}
</style>
